import type { WizardData } from '../ActorGenerationWizard';
import styles from './Steps.module.css';

// character_traits の文字数上限 (BE actor_admin_service.CHARACTER_TRAITS_MAX_LENGTH と同値)
export const CHARACTER_TRAITS_MAX_LENGTH = 500;

type Props = {
  data: WizardData;
  onUpdate: (updates: Partial<WizardData>) => void;
};

/**
 * Step 5 (キャラクター俳優のみ): キャラクターの特徴・設定テキストの登録。
 *
 * ここで入力したテキストは prompt_models.character_traits に保存され、
 * シナリオ生成・絵コンテ/動画生成の AI プロンプトへ**そのまま**追加される。
 * 任意入力 (空のままでも登録できる)。
 */
export function CharacterTraitsStep({ data, onUpdate }: Props) {
  return (
    <div className={styles.stepContainer}>
      <div className={styles.compactForm}>
        <div className={styles.formGroupFull}>
          <label className={styles.label}>キャラクターの特徴・設定（任意）</label>
          <textarea
            className={styles.textarea}
            value={data.characterTraits}
            onChange={(e) => onUpdate({ characterTraits: e.target.value })}
            placeholder={'例: 身長は15cm。腕が伸びる。語尾に「〜エイト」と付けて話す。'}
            rows={6}
            maxLength={CHARACTER_TRAITS_MAX_LENGTH}
          />
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              gap: 12,
              fontSize: 12,
              color: 'rgba(245, 241, 230, 0.55)',
              lineHeight: 1.6,
            }}
          >
            <span>
              入力したテキストは、シナリオ生成や動画生成の際に<strong>そのままAIへのプロンプト（指示文）として追加されます</strong>。
              体のサイズ・特殊な能力・性格・話し方など、生成に反映させたい設定を短い文で記述してください。
              あとから編集画面でも変更できます。
            </span>
            <span style={{ flexShrink: 0 }}>
              {data.characterTraits.length}/{CHARACTER_TRAITS_MAX_LENGTH}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
